/**
 * A picker value is a user id, or `tech:<id>` for a technician with no login.
 * Technicians who DO have a login are listed as their user, so each person
 * appears once and the task keeps notifying them through the user.
 */
export const TECH_PREFIX = 'tech:';

export function taskAssigneeValue(task: {
  assignedTo?: string | null;
  technicianId?: string | null;
}): string {
  if (task.assignedTo) return task.assignedTo;
  return task.technicianId ? `${TECH_PREFIX}${task.technicianId}` : '';
}

/** The API fields for a picker value; both are always sent so switching
 *  between a user and a login-less technician clears the other. */
export function taskAssigneePayload(value: string): {
  assignedTo: string | null;
  technicianId: string | null;
} {
  if (value.startsWith(TECH_PREFIX)) {
    return { assignedTo: null, technicianId: value.slice(TECH_PREFIX.length) };
  }
  return { assignedTo: value || null, technicianId: null };
}
